<div class="movement-orders no-field-space" *ngIf="serviceTruckOptions.length > 0">
  <sc-flex [stretchContent]="true" [fitHeight]="true">
    <sc-flex-fitting-content>
      <sc-flex [stretchContent]="true" [fitHeight]="true" [vertical]="true">
        <div>
          <sc-flex>
            <mat-form-field appearance="fill">
              <mat-label>Servicefahrzeug</mat-label>
              <mat-select [formControl]="serviceTruckSelectionControl">
                <mat-option *ngFor="let value of serviceTruckOptions" [value]="value">
                  {{value.identifier}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="truckGroupsEnabled">
              <ng-container *ngFor="let tg of truckGroupsOfSelectedTruck">
                <sc-content-spacer></sc-content-spacer>
                <sc-bordered [rounded]="true" [highlight]="tg.id === selectedTruckGroup?.id"
                  (click)="selectTruckGroup(tg)">
                  <sc-padding>
                    {{tg.name}}
                  </sc-padding>
                </sc-bordered>
              </ng-container>
            </ng-container>
          </sc-flex>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <sc-flex-fitting-content [vertical]="true">


          <sc-scroll-pane>
            <table mat-table [dataSource]="dataSource">
              <ng-container matColumnDef="priority">
                <th mat-header-cell *matHeaderCellDef>
                  {{'Priorität'| translate:['tmc-yard.entity.moving-order.priority', translationService.language]}}
                </th>
                <td mat-cell *matCellDef="let row">
                  <sc-icon iconClass="fa-circle-exclamation" *ngIf="row.priority"></sc-icon>
                </td>
              </ng-container>

              <ng-container matColumnDef="referenceDate">
                <th mat-header-cell *matHeaderCellDef>
                  {{'Referenzdatum'| translate:['tmc-yard.entity.moving-order.referenceDate',
                  translationService.language]}}
                </th>
                <td mat-cell *matCellDef="let row"> {{row.referenceDate | date:'dd.MM.yy H:mm'}} </td>
              </ng-container>

              <ng-container matColumnDef="scope">
                <th mat-header-cell *matHeaderCellDef>
                  {{'Umfang'| translate:['tmc-yard.entity.moving-order.scope', translationService.language]}}
                </th>
                <td mat-cell *matCellDef="let row">
                  <app-transport-scope-icon [scope]="row.scope"></app-transport-scope-icon>
                </td>
              </ng-container>

              <ng-container matColumnDef="identifier">
                <th mat-header-cell *matHeaderCellDef>
                  {{'Transportmerkmal'| translate:['tmc-yard.entity.moving-order.identifier',
                  translationService.language]}}
                </th>
                <td mat-cell *matCellDef="let row"> {{row.identifier}} </td>
              </ng-container>

              <ng-container matColumnDef="transportReference">
                <th mat-header-cell *matHeaderCellDef>
                  {{'Referenz'| translate:['tmc-yard.entity.moving-order.transportReference',
                  translationService.language]}}
                </th>
                <td mat-cell *matCellDef="let row"> {{row.transportReference}} </td>
              </ng-container>

              <ng-container matColumnDef="currentStation">
                <th mat-header-cell *matHeaderCellDef>
                  {{'akt. Station'| translate:['tmc-yard.entity.moving-order.currentStation',
                  translationService.language]}}
                </th>
                <td mat-cell *matCellDef="let row"> {{row.currentStation}} </td>
              </ng-container>

              <ng-container matColumnDef="targetStation">
                <th mat-header-cell *matHeaderCellDef>
                  {{'Zielstation'| translate:['tmc-yard.entity.moving-order.targetStation',
                  translationService.language]}}
                </th>
                <td mat-cell *matCellDef="let row"> {{row.targetStation}} </td>
              </ng-container>

              <ng-container matColumnDef="movementStrategy">
                <th mat-header-cell *matHeaderCellDef>
                  {{'movement Strategy'| translate:['tmc-yard.entity.moving-order.movementStrategy.label',
                  translationService.language]}}
                </th>
                <td mat-cell *matCellDef="let row">
                  <ng-container *ngIf="row.movementStrategy">
                  {{row.movementStrategy |
                  translate:['tmc-yard.entity.moving-order.movementStrategy.' + row.movementStrategy,
                  translationService.language]}}
                  </ng-container>
                </td>
              </ng-container>

              <ng-container matColumnDef="processingStatus">
                <th mat-header-cell *matHeaderCellDef>
                  {{'Bearbeitungsstatus'| translate:['tmc-yard.entity.moving-order.processingStatus.label',
                  translationService.language]}}
                </th>
                <td mat-cell *matCellDef="let row">{{row.processingStatus |
                  translate:['tmc-yard.entity.moving-order.processingStatus.' + row.processingStatus,
                  translationService.language]}}
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: false"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplay" [ngClass]="getRowStyles(row)"
                (click)="toggleSelection(row)"></tr>

            </table>
          </sc-scroll-pane>
        </sc-flex-fitting-content>
      </sc-flex>
    </sc-flex-fitting-content>
    <sc-content-spacer></sc-content-spacer>
    <div class="details-column">
      <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
        <sc-title>Details</sc-title>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <sc-flex-fitting-content [vertical]="true">
          <app-movement-order-details [movementOrderDetailsId]="movementOrderDetails?.id"
            [serviceTruckId]="selectedServiceTruck?.truckId" (detailsChanged)="onMovementOrderDetailsChanged()">
          </app-movement-order-details>
        </sc-flex-fitting-content>
      </sc-flex>
    </div>
  </sc-flex>
</div>
<sc-flex [centered]="true" [fitHeight]="true" [vertical]="true" *ngIf="serviceTruckOptions.length === 0">
  <sc-icon iconClass="fa-truck-flatbed fa-6x"></sc-icon>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <div>no Service Truck available</div>
</sc-flex>
